//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { server } from "@/services/constants";

// ✅ ไฟล์ incorporate อยู่ที่ production storage port 3001
const INCORPORATE_MATTER_FILE_URL = process.env.VUE_APP_PRODUCTION_STORAGE_URL
  ? `${process.env.VUE_APP_PRODUCTION_STORAGE_URL}/incorporatematter`
  : "http://localhost:3001/incorporatematter";
import {
  getIncorporateMatterById,
  getIncorporateDocketByMatterId,
} from "@/services/api-dtime/api_incorporate";

export default {
  name: "incorporate-matter-view",
  data() {
    return {
      loading: true,
      matter: null,
      dockets: [],
      activeTab: 0,
      fileIncorporateUrl: INCORPORATE_MATTER_FILE_URL,
    };
  },
  computed: {
    isIndividual() {
      return this.matter?.entity_type === "Individual";
    },
    totalOrdinaryShares() {
      return (this.matter?.shareholders || []).reduce(
        (sum, sh) => sum + (Number(sh.ordinary_shares) || 0),
        0,
      );
    },
    totalPreferredShares() {
      return (this.matter?.shareholders || []).reduce(
        (sum, sh) => sum + (Number(sh.preferred_shares) || 0),
        0,
      );
    },
    // คำนวณ % ด้วย Largest Remainder Method ให้ผลรวมลงตัวพอดี (เหมือนหน้า Add/Edit)
    ownershipPercentages() {
      const list = this.matter?.shareholders || [];
      const base = Number(this.matter?.number_of_shares) || 0;
      const n = list.length;
      if (!base || !n) return list.map(() => 0);

      const SCALE = 100000;
      const raw = list.map(
        (sh) => ((Number(sh.ordinary_shares) || 0) / base) * 100 * SCALE,
      );

      const floors = raw.map((r) => Math.floor(r));
      const target = Math.round(raw.reduce((a, b) => a + b, 0));
      const remainder = target - floors.reduce((a, b) => a + b, 0);

      const order = raw
        .map((r, i) => ({ i, frac: r - Math.floor(r) }))
        .sort((a, b) => b.frac - a.frac || a.i - b.i);

      const units = floors.slice();
      for (let k = 0; k < remainder; k++) {
        units[order[k % n].i] += 1;
      }

      return units.map((u) => u / SCALE);
    },
    totalPercentage() {
      return this.ownershipPercentages.reduce((a, b) => a + b, 0);
    },
  },
  async beforeCreate() {
    this.$store.state.navMenu = true;
  },
  async mounted() {
    this.$hideLoader();
    const id = this.$route.params.id;
    await this.loadMatter(id);
    await this.loadDockets(id);
    this.loading = false;
  },
  methods: {
    formatPercent(v) {
      return (Number(v) || 0).toFixed(5) + "%";
    },
    async loadMatter(id) {
      try {
        const res = await getIncorporateMatterById(id);
        this.matter = res.data;
        // ถ้า findById return พร้อม dockets แล้ว
        if (this.matter?.dockets) {
          this.dockets = this.matter.dockets;
        }
      } catch (error) {
        console.error("Error loading matter:", error);
      }
    },

    async loadDockets(id) {
      try {
        const res = await getIncorporateDocketByMatterId(id);
        this.dockets = res.data || [];
      } catch (error) {
        console.error("Error loading dockets:", error);
      }
    },

    goToEdit() {
      this.$router.push(`/incorporate-matter-edit/${this.matter.id}`);
    },

    goToNewDocket() {
      this.$router.push(`/incorporate-docket-add?matter_id=${this.matter.id}`);
    },

    formatDate(dateStr) {
      if (!dateStr) return "-";
      try {
        const d = new Date(dateStr);
        return d.toLocaleDateString("th-TH", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        });
      } catch {
        return dateStr;
      }
    },

    formatNumber(val) {
      if (val === null || val === undefined || val === "") return "0";
      return Number(val).toLocaleString("th-TH");
    },

    getDocketStatusColor(status) {
      const map = {
        "In Progress": "blue lighten-4",
        Complete: "green lighten-4",
        Cancelled: "red lighten-4",
      };
      return map[status] || "grey lighten-3";
    },
  },
};
